import { createContext, useContext } from 'react';

const initialState = {
  addressSetting: null,
  storesList: [],
  selectStoreButtonLabel: '',
  // eslint-disable-next-line no-unused-vars
  onSearchStore: (_keyword) => {
  },
  // eslint-disable-next-line no-unused-vars
  onFilterArea: (_params) => {
  },
  onClearFilter: () => {
  },
  // eslint-disable-next-line no-unused-vars
  onStoreSelect: (_storeData) => {
  }
};
const PickupFromStoreContext = createContext(initialState);

export const usePickupFromStoreContext = () => useContext(PickupFromStoreContext);

export default PickupFromStoreContext;